import { IMediaUploadResponse } from '../feeds/interface';
import paths from '../paths';
import { axiosQnAClient } from './axiosQnAClient';
import { IQnAListResponse, IQnAReplyItem, IQuestionAnswer } from './qnaInterface';

export interface IPostQuestionPayload {
  userId?: string;
  realmId?: string;
}
export interface IPostQuestionBody {
  type: string;
  name: string;
  title: string;
  body: string;
  space: string;
  tags: Array<string>;
  creatorid: string;
  videoUrls: Array<string>;
  audioUrls: Array<string>;
  parentid?: string;
  medias?: IMediaUploadResponse[];
}

export const postQuestionAsync = async (
  config: IPostQuestionPayload,
  body: IPostQuestionBody
): Promise<IQuestionAnswer> => {
  try {
    const response = await axiosQnAClient.post(paths.postQuestionPath(config), body);
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const postQuestionReplyAsync = async (
  config: IPostQuestionPayload,
  body: IPostQuestionBody
): Promise<IQnAReplyItem> => {
  try {
    const response = await axiosQnAClient.post<IQnAReplyItem>(paths.postQuestionPath(config), body);
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const moderationPostQuestionAndFeedAsync = async (
  config: IPostQuestionPayload,
  body: object
): Promise<IQnAListResponse> => {
  try {
    const response = await axiosQnAClient.post(paths.createModerationQuestionAndFeed(config), body);
    return response.data?.data;
  } catch (e) {
    throw e;
  }
};
